import { IonCard } from "@ionic/react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { DashBoardComponentProps } from "../data/data";

import { useEffect, useState } from "react";
import { Loading } from "./Loading";
import { ClientAvatar } from "../../../lovable/components/ClientAvatar";
import { EditMode } from "../../../lovable/components/EditMode";
import { formatImage } from "../../utils/image-utils";
import { formatDate } from "../../utils/date-utils";
import { initSession } from "../../utils/http-service";
import { MeasureData } from "../../utils/interfaces";

export const HomeTab: React.FC<DashBoardComponentProps> = ({
  clientHolder,
  clientData,
  measurementDatas,
  shared,
}) => {
  const history = useHistory();

  const id = useParams<{ id: string }>().id;
  const [isEditMode, setIsEditMode] = useState(false);
  const sorted = measurementDatas.sort((a, b) =>
    new Date(a.createdAt) > new Date(b.createdAt) ? -1 : 1
  );

  const firstWeight = sorted.find((s) => s.measurements.weight)?.measurements
    .weight;
  const weight = String(firstWeight ?? "0");
  const lastScan =
    measurementDatas.length > 0
      ? formatDate(new Date(sorted[0].createdAt))
      : undefined;

  const fetchData = async () => {
    console.log("Fetch client data for id: ", id);
    clientHolder.load();
  };

  const handleDeleteMeasurement = async (measurementIds: string[]) => {
    console.log("Delete measurement with id: ", measurementIds);
    clientHolder.deleteMeasurements(measurementIds);
  };
  const confirmMeasurement = async (measurement: MeasureData) => {
    console.log("Confirm measurement with id: ", measurement.ID);
    clientHolder.onConfirmMeasurement(measurement);
  };
  const doStartScan = async () => {
    if (!id) {
      console.warn("No client ID provided");
      return;
    }
    if (!clientData) {
      console.warn("No client data available");
      return;
    }
    const session = await initSession(clientData, clientHolder.auth);
    if (!session.ID) {
      console.warn("No session ID returned from initSession");
      return;
    }
    const scanPath = session.scanUrl
      ? new URL(session.scanUrl).pathname + new URL(session.scanUrl).search
      : `/scan/${clientData.ID}/${session.ID}`;
    history.push(scanPath);
  };
  const handleDeleteClient = async () => {
    const res = await clientHolder.deleteClient();
    setIsEditMode(false);

    if (!res) {
      console.error("Failed to delete client");
      return;
    }
    history.push(`/clients`);
  };
  useEffect(() => {
    fetchData();
  }, [id]);
  const renderContent = () => {
    if (!clientData) {
      return <Loading />;
    }

    if (isEditMode) {
      return (
        <EditMode
          gender={clientData.gender}
          onConfirmMeasurement={confirmMeasurement}
          measurements={measurementDatas}
          onDeleteMeasurement={handleDeleteMeasurement}
          onDeleteClient={handleDeleteClient}
          onClose={() => setIsEditMode(false)}
        />
      );
    }

    return (
      <ClientAvatar
        onStartScan={() => {
          doStartScan();
        }}
        onSendScanLink={async () => {
          if (!id || !clientData) return undefined;
          const session = await initSession(clientData, clientHolder.auth);
          return session.scanUrl || undefined;
        }}
        clientID={clientData.ID}
        shared={shared}
        name={clientData.firstName + " " + clientData.lastName}
        age={clientData.age}
        onShare={async (enabled: boolean) => {
          return await clientHolder.onShare(enabled);
        }}
        weight={weight}
        weightUnit="kg"
        lastScan={lastScan}
        imageUrl={formatImage(clientData?.profileImage ?? "")}
        onEdit={() => setIsEditMode(true)}
      />
    );
  };

  return <IonCard>{renderContent()}</IonCard>;
};

export default HomeTab;
